/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CreateNotificationRequest} from '../models/CreateNotificationRequest';
import type {Error} from '../models/Error';
import type {Notification} from '../models/Notification';
import type {UpdateNotificationRequest} from '../models/UpdateNotificationRequest';

export interface CreateNotification$Request {
    createNotificationRequest: CreateNotificationRequest;
}

export interface CreateNotification$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createNotificationRequest = createAction<PayloadData<void, CreateNotification$Request>>('INTERNAL_NOTIFICATION__CREATE_NOTIFICATION__REQUEST');
export const createNotificationSuccess = createAction<PayloadData<void, CreateNotification$Request>>('INTERNAL_NOTIFICATION__CREATE_NOTIFICATION__SUCCESS');
export const createNotificationFailure = createAction<PayloadData<Error, CreateNotification$Request, true>>('INTERNAL_NOTIFICATION__CREATE_NOTIFICATION__FAILURE');

export const createNotificationActions = [
    createNotificationRequest,
    createNotificationSuccess,
    createNotificationFailure
] as const;

/**
 * @param {CreateNotificationRequest} meta.createNotificationRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createNotification = (meta: CreateNotification$Request, config?: CreateNotification$Config) => {
    return {
        CALL_API: {
            types: createNotificationActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/internal-notifications`,
            TRANSPORT_REQUEST_BODY: meta.createNotificationRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DeleteNotification$Request {
    notificationId: string;
}

export interface DeleteNotification$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteNotificationRequest = createAction<PayloadData<void, DeleteNotification$Request>>('INTERNAL_NOTIFICATION__DELETE_NOTIFICATION__REQUEST');
export const deleteNotificationSuccess = createAction<PayloadData<void, DeleteNotification$Request>>('INTERNAL_NOTIFICATION__DELETE_NOTIFICATION__SUCCESS');
export const deleteNotificationFailure = createAction<PayloadData<Error, DeleteNotification$Request, true>>('INTERNAL_NOTIFICATION__DELETE_NOTIFICATION__FAILURE');

export const deleteNotificationActions = [
    deleteNotificationRequest,
    deleteNotificationSuccess,
    deleteNotificationFailure
] as const;

/**
 * @param {string} meta.notificationId The id of the notification to fetch
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteNotification = (meta: DeleteNotification$Request, config?: DeleteNotification$Config) => {
    return {
        CALL_API: {
            types: deleteNotificationActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/internal-notifications/${meta.notificationId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface FetchNotification$Request {
    notificationId: string;
}

export interface FetchNotification$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const fetchNotificationRequest = createAction<PayloadData<void, FetchNotification$Request>>('INTERNAL_NOTIFICATION__FETCH_NOTIFICATION__REQUEST');
export const fetchNotificationSuccess = createAction<PayloadData<Notification, FetchNotification$Request>>('INTERNAL_NOTIFICATION__FETCH_NOTIFICATION__SUCCESS');
export const fetchNotificationFailure = createAction<PayloadData<Error, FetchNotification$Request, true>>('INTERNAL_NOTIFICATION__FETCH_NOTIFICATION__FAILURE');

export const fetchNotificationActions = [
    fetchNotificationRequest,
    fetchNotificationSuccess,
    fetchNotificationFailure
] as const;

/**
 * @param {string} meta.notificationId The id of the notification to fetch
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const fetchNotification = (meta: FetchNotification$Request, config?: FetchNotification$Config) => {
    return {
        CALL_API: {
            types: fetchNotificationActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/internal-notifications/${meta.notificationId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetNotificationTopics$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getNotificationTopicsRequest = createAction<PayloadData<void>>('INTERNAL_NOTIFICATION__GET_NOTIFICATION_TOPICS__REQUEST');
export const getNotificationTopicsSuccess = createAction<PayloadData<Array<string>>>('INTERNAL_NOTIFICATION__GET_NOTIFICATION_TOPICS__SUCCESS');
export const getNotificationTopicsFailure = createAction<PayloadData<Error, void, true>>('INTERNAL_NOTIFICATION__GET_NOTIFICATION_TOPICS__FAILURE');

export const getNotificationTopicsActions = [
    getNotificationTopicsRequest,
    getNotificationTopicsSuccess,
    getNotificationTopicsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getNotificationTopics = (config?: GetNotificationTopics$Config) => {
    return {
        CALL_API: {
            types: getNotificationTopicsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/internal-notifications/topics`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface UpdateNotification$Request {
    notificationId: string;
    updateNotificationRequest: UpdateNotificationRequest;
}

export interface UpdateNotification$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateNotificationRequest = createAction<PayloadData<void, UpdateNotification$Request>>('INTERNAL_NOTIFICATION__UPDATE_NOTIFICATION__REQUEST');
export const updateNotificationSuccess = createAction<PayloadData<void, UpdateNotification$Request>>('INTERNAL_NOTIFICATION__UPDATE_NOTIFICATION__SUCCESS');
export const updateNotificationFailure = createAction<PayloadData<Error, UpdateNotification$Request, true>>('INTERNAL_NOTIFICATION__UPDATE_NOTIFICATION__FAILURE');

export const updateNotificationActions = [
    updateNotificationRequest,
    updateNotificationSuccess,
    updateNotificationFailure
] as const;

/**
 * @param {string} meta.notificationId The id of the notification to update
 * @param {UpdateNotificationRequest} meta.updateNotificationRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateNotification = (meta: UpdateNotification$Request, config?: UpdateNotification$Config) => {
    return {
        CALL_API: {
            types: updateNotificationActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/internal-notifications/${meta.notificationId}`,
            TRANSPORT_REQUEST_BODY: meta.updateNotificationRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

